import { defineComponent as w, computed as A, createBlock as l, openBlock as i, unref as T, withCtx as c, createElementVNode as L, createVNode as $, TransitionGroup as b, createElementBlock as B, Fragment as k, renderList as E, toRaw as r } from "vue";
import { RevPortal as R } from "@ds/components/Portal";
import { useToast as F } from "@ds/composables/useToast";
import { tw as n } from "../../utils/tailwind.js";
import I from "./components/ToastItem.vue2.js";
const N = { class: "pointer-events-none fixed inset-x-0 top-0 gap-12 p-24 md:p-16" }, j = /* @__PURE__ */ w({
  name: "RevToast",
  inheritAttrs: !1,
  __name: "Toast",
  props: {
    to: { default: "body" }
  },
  setup(d) {
    const a = F(), f = A(() => a.toasts), m = n`-translate-y-full opacity-0 md:translate-x-full md:translate-y-0`, p = n`ease-in-out motion-safe:transition-all motion-safe:duration-300`, u = n`absolute ease-in-out motion-safe:transition-all motion-safe:duration-150`, v = n`-translate-y-full opacity-0 md:translate-x-full md:translate-y-0`, h = n`ease-in-out motion-safe:transition-all motion-safe:duration-150`;
    function C(o) {
      const e = o, { marginLeft: t, marginTop: s, width: y, height: g } = window.getComputedStyle(e);
      o.setAttribute(
        "style",
        `
    left: ${e.offsetLeft - parseInt(t, 10)}px;
    top: ${e.offsetTop - parseInt(s, 10)}px;
    width: ${y};
    height: ${g};
  `
      );
    }
    function _(o) {
      const e = r(o);
      e.onClose && e.onClose(), a.dismiss(e.id);
    }
    function x(o) {
      const e = r(o);
      e.onAction && e.onAction(), a.dismiss(e.id);
    }
    return (o, e) => (i(), l(T(R), { to: d.to }, {
      default: c(() => [
        L("div", N, [
          $(b, {
            class: "relative flex flex-col items-stretch gap-12 md:items-end",
            "enter-active-class": p,
            "enter-from-class": m,
            "leave-active-class": u,
            "leave-to-class": v,
            "move-class": h,
            tag: "div",
            onBeforeLeave: C
          }, {
            default: c(() => [
              (i(!0), B(k, null, E(f.value, (t) => (i(), l(I, {
                key: t.id,
                "action-label": t.actionLabel,
                description: t.description,
                duration: t.duration,
                icon: r(t.icon),
                "icon-props": t.iconProps,
                "icon-src": t.iconSrc,
                name: t.id,
                title: t.title,
                variant: t.variant,
                onAction: (s) => x(t),
                onClose: (s) => _(t)
              }, null, 8, ["action-label", "description", "duration", "icon", "icon-props", "icon-src", "name", "title", "variant", "onAction", "onClose"]))), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["to"]));
  }
});
export {
  j as default
};
